export interface WindowMessageEvent {
  type: string;
  data: any;
}
